var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-container"},[_c('gallery',{attrs:{"items":_vm.images,"origin":_vm.origin},on:{"close":function($event){_vm.origin = null}}}),_vm._l((_vm.images),function(image,imageIndex){return _c('div',{key:image.href,staticClass:"image",style:({
      backgroundImage: 'url(' + image.href + ')',
    }),on:{"click":function($event){_vm.origin = imageIndex}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }